import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  InputFieldModule,
  InputSelectAddonModule,
  InputSelectModule,
  InputSubmitModule,
  ModalModule,
  TitleModule
} from 'src/app/components';
import { ReRouteModalComponent } from './re-route-modal.component';
import { BookingCredentialsModule } from 'src/app/components/booking-credentials/booking-credentials.module';

@NgModule({
  declarations: [ReRouteModalComponent],
  imports: [
    CommonModule,
    InputSelectModule,
    InputSubmitModule,
    InputFieldModule,
    ReactiveFormsModule,
    TranslateModule,
    ModalModule,
    InputSelectAddonModule,
    TitleModule,
    BookingCredentialsModule
  ],
  exports: [ReRouteModalComponent]
})
export class ReRouteModalModule {}
